import { render, staticRenderFns } from "./superSearchInput.vue?vue&type=template&id=3727caa4&"
import script from "./superSearchInput.vue?vue&type=script&lang=js&"
export * from "./superSearchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/superSearch/superSearchInput.vue"
export default component.exports